export const initPostMetaViewCount = (): void => {
  const container = document.querySelector<HTMLElement>("[data-post-id]");
  if (!container) return;

  const postId = container.dataset.postId;

  // ScriptLocalizationService tarafından sağlanan ortak değişkenler
  const nonce = (window as any).commonVariables?.generalNonce;
  const ajaxUrl = (window as any).commonVariables?.ajaxUrl;

  if (!postId || !nonce || !ajaxUrl) return;

  // --- YENİ EKLENEN KONTROL ---
  // Aynı oturumda (sekmede) bu yazıya daha önce bakıldıysa tekrar AJAX isteği atma
  const sessionKey = `viewed_post_${postId}`;
  if (sessionStorage.getItem(sessionKey)) {
    return; // Daha önce sayılmış, işlemi burada durdur.
  }
  // ---------------------------

  // Botları ve anında çıkışları (bounce) saymamak için 3 saniye bekliyoruz
  setTimeout(() => {
    const formData = new URLSearchParams();
    formData.append("action", "increment_post_view");
    formData.append("post_id", postId);
    formData.append("nonce", nonce);

    fetch(ajaxUrl, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success && data.data && data.data.views) {
          // Başarıyla sayıldı! Bir dahaki yenilemede sayılmaması için Session'a not bırak
          sessionStorage.setItem(sessionKey, "true");
        }
      })
      .catch((error) =>
        console.error("[PostMeta] Failed to increment view:", error),
      );
  }, 3000);
};
